"use client";

import Image from "next/image";

const VALUES = [
  {
    id: "1",
    title: "Life-Work Harmony",
    description:
      "We see everyone we work with as whole people who live full lives. We strive to maintain functional benefits and emotional security at work to fuel a life that can thrive outside of work.",
    image: "/assets/graphics/culture-lifework.webp",
  },
  {
    id: "2",
    title: "Supportive Growth",
    description:
      "There are few things we love more than seeing each other flourish. We provide our employees and client partners with the foundation and means to grow together.",
    image: "/assets/graphics/culture-growth.webp",
  },
  {
    id: "3",
    title: "Healthy Longevity",
    description:
      "Our purpose is to build for the long-term by fostering an ongoing sense of stability. We adapt to the environment around us so we can sustain the lives of the teams who are working on the products of the future.",
    image: "/assets/graphics/culture-longevity.webp",
  },
  {
    id: "4",
    title: "Transparency Always",
    description:
      "We opt for transparency at every level, whenever possible. It’s one of the most powerful tools available to us when striving for equity. We keep things transparent because we stand behind our decisions.",
    image: "/assets/graphics/culture-transparency.webp",
  },
];

export default function ValuesCards() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {VALUES.map((value) => (
        <div
          key={value.id}
          className="p-6 bg-card-texture dark:bg-gray-800 rounded-lg shadow-sm h-full"
        >
          <div className="relative h-48 mb-6">
            <Image
              src={value.image}
              alt={`Illustration for ${value.title}`}
              fill
              className="object-contain"
              sizes="(max-width: 768px) 100vw, 50vw"
            />
          </div>
          <h3 className="text-2xl font-medium mb-4">{value.title}</h3>
          <p className="text-lg leading-relaxed text-gray-600 dark:text-gray-300">
            {value.description}
          </p>
        </div>
      ))}
    </div>
  );
}
